import { gql } from "apollo-boost";

export const GET_COURSEOUTLINES_DDL = gql`
  query getCourseOutlines {
    getCourseOutlines {
      id subjectCode teacherCode
      degree {
        id
      }
      subjectGroup {
        id
      }
      subject {
        id
      }
      teacher {
        id
      }
      courseOutlineUnits {
        id
      }
      vdoSets {
        id
      }
    }
  }
`;

export const GET_COURSEOUTLINE = gql`
  query getCourseOutline($id: ID!) {
    getCourseOutline(
      id: $id
    ) {
      id subjectCode teacherCode totalPoint instruction streamIntroPath bookName1 picturePath verticalPicturePath
      bookPic1 bookDescription1 bookName2 bookPic2 bookDescription2 bookName3 bookPic3 bookDescription3
      degree {
        id code nameLocal nameEng
      }
      subjectGroup {
        id code nameLocal nameEng
      }
      subject {
        id code nameLocal nameEng creditCalGrade creditDesc
      }
      teacher {
        id code firstNameLocal lastNameLocal firstNameEng lastNameEng picturePath
      }
      courseOutlineUnits {
        id seq nameLocal nameEng descriptionLocal descriptionEng preTestExpectScore
        postTestExpectScore unitAgenda unitObjective unitReference countLearnPercent
      }
      courseOutlineAssessments {
        id seq percent score
        assessment{
          id nameLocal nameEng
        }
      }
      vdoSets {
        id code description totalVdoLength
        vdoSetUnits {
          id unitSeq code totalVdoLength status remark
          courseOutlineUnit{ id nameLocal nameEng}
          vdoSetTopics {
            id no nameLocal nameEng vdoLength vdoStreamPath isEnabled remark descriptionLocal descriptionEng thumbnail
            playbackUrl
            playbackStatus
            videoProvider bunnyVideoGuid bunnyStatus bunnyStatusAt
          }
        }
      }
    }
  }
`;

export const GET_COURSEOUTLINES = gql`
  query getCourseOutlines {
    getCourseOutlines {
      id subjectCode teacherCode totalPoint instruction streamIntroPath bookName1
      bookPic1 bookDescription1 bookName2 bookPic2 bookDescription2 bookName3 bookPic3 bookDescription3
      degree {
        id code nameLocal nameEng
      }
      subjectGroup {
        id code nameLocal nameEng
      }
      subject {
        id code nameLocal nameEng
      }
      teacher {
        id code firstNameLocal lastNameLocal firstNameEng lastNameEng picturePath
      }
      courseOutlineAssessments {
        id seq percent score
        assessment{
          id nameLocal nameEng
        }
      }
      vdoSets {
        id code description totalVdoLength
      }
    }
  }
`;

export const GET_COURSEOUTLINES_BY_FILTER = gql`
  query getCourseOutlinesByFilter(
    $courseOutlineFilterInput: CourseOutlineFilterInput
    #    degreeId: ID
    #    subjectGroupId: ID
    #    subjectId: ID
    #    subjectCode: String
    #    teacherId: ID
    #    teacherCode: String
  )
  {
    getCourseOutlinesByFilter (
      courseOutlineFilterInput: $courseOutlineFilterInput
    )
    {
      id subjectCode teacherCode totalPoint instruction streamIntroPath bookName1
      bookPic1 bookDescription1 bookName2 bookPic2 bookDescription2 bookName3 bookPic3 bookDescription3
      degree {
        id code nameLocal nameEng
      }
      subjectGroup {
        id code nameLocal nameEng
      }
      subject {
        id code nameLocal nameEng
      }
      teacher {
        id code firstNameLocal lastNameLocal firstNameEng lastNameEng picturePath
      }
      courseOutlineUnits {
        id
        #        seq nameLocal nameEng descriptionLocal descriptionEng preTestExpectScore
        #        postTestExpectScore unitAgenda unitObjective unitReference
      }
      courseOutlineAssessments {
        id seq percent score
        assessment{
          id nameLocal nameEng
        }
      }
      vdoSets {
        id code description totalVdoLength code
        vdoSetUnits{
          id
          vdoSetTopics { id vdoStreamPath playbackUrl playbackStatus videoProvider bunnyVideoGuid bunnyStatus }
        }
      }
    }
  }
`;

export const GET_COURSEOUTLINEUNITS_BY_COURSEOUTLINEID = gql`
  query getCourseOutlineUnitsByCourseOutlineId(
    $courseOutlineId: ID!
  )
  {
    getCourseOutlineUnitsByCourseOutlineId (
      courseOutlineId: $courseOutlineId
    )
    {
      id seq nameLocal nameEng descriptionLocal descriptionEng
    }
  }
`;

export const GET_COURSEOUTLINES_BY_FILTER_FOR_TABLE = gql`
  query getCourseOutlinesByFilter(
    $courseOutlineFilterInput: CourseOutlineFilterInput
  )
  {
    getCourseOutlinesByFilter (
      courseOutlineFilterInput: $courseOutlineFilterInput
    )
    {
      id
      subject {
        id code nameLocal nameEng creditCalGrade
      }
      teacher {
        id code firstNameLocal lastNameLocal firstNameEng lastNameEng picturePath
      }
      courseOutlineUnits {
        id
      }
      vdoSets {
        id
        #        totalVdoLength
        #        vdoSetUnits{
        #          id
        #          vdoSetTopics { id vdoStreamPath }
        #        }
      }
    }
  }
`;

export const GET_COURSEOUTLINES_AVAILABLE = gql`
  query getCourseOutlinesAvailable(
    $subjectId: ID!,
    $teacherId: ID!,
    $academicPeriodId: ID!
  )
  {
    getCourseOutlinesAvailable (
      subjectId: $subjectId
      teacherId: $teacherId
      academicPeriodId: $academicPeriodId
    )
    {
      id
      teacher {
        id code firstNameLocal lastNameLocal firstNameEng lastNameEng picturePath
      }
    }
  }
`;

export const GET_COURSEOUTLINES_PAGINATION = gql`
  query courseOutlinesPagination(
    $filter: String
    $where: CourseOutlineFilterInput
    $pageSize: Int
    $currentPage: Int
    $orderBy: CourseOutlinesOrderByInput!) {
    courseOutlinesPagination(
      filter: $filter
      where: $where
      pageSize: $pageSize
      currentPage: $currentPage
      orderBy: $orderBy
    ) {
      nodes {
        id
        subject {
          id code nameLocal nameEng creditCalGrade
        }
        teacher {
          id code firstNameLocal lastNameLocal firstNameEng lastNameEng picturePath
        }
        courseOutlineUnits {
          id
        }
        vdoSets {
          id
          #        totalVdoLength
          #        vdoSetUnits{
          #          id
          #          vdoSetTopics { id vdoStreamPath }
          #        }
        }
      }
      pageInfo {
        fromItem
        toItem
        currentPage
        pageSizes
        totalItemsInPage
        totalPage
        totalItems
      }
    }
  }
`;

export const GET_COURSEOUTLINES_NOT_OPEN_PAGINATION = gql`
  query courseOutlinesNotOpenPagination(
    $filter: String
    $where: CourseOutlineFilterInput
    $pageSize: Int
    $currentPage: Int
    $orderBy: CourseOutlinesOrderByInput!) {
    courseOutlinesNotOpenPagination(
      filter: $filter
      where: $where
      pageSize: $pageSize
      currentPage: $currentPage
      orderBy: $orderBy
    ) {
      nodes {
        id
        subject {
          id code nameLocal nameEng creditCalGrade
        }
        teacher {
          id code firstNameLocal lastNameLocal firstNameEng lastNameEng picturePath
        }
        courseOutlineUnits {
          id
        }
        vdoSets {
          id
          #        totalVdoLength
          #        vdoSetUnits{
          #          id
          #          vdoSetTopics { id vdoStreamPath }
          #        }
        }
      }
      pageInfo {
        fromItem
        toItem
        currentPage
        pageSizes
        totalItemsInPage
        totalPage
        totalItems
      }
    }
  }
`;


export const ADD_COURSEOUTLINE = gql`
  mutation addCourseOutline(
    $degreeId: ID!,
    $subjectGroupId: ID!,
    $subjectId: ID!,
    $subjectCode: String!,
    $teacherId: ID!,
    $teacherCode: String!
  ) {
    addCourseOutline (
      degreeId: $degreeId,
      subjectGroupId: $subjectGroupId,
      subjectId: $subjectId,
      subjectCode: $subjectCode,
      teacherId: $teacherId,
      teacherCode: $teacherCode
    ) {
      id subjectCode teacherCode totalPoint instruction streamIntroPath bookName1 picturePath verticalPicturePath
      bookPic1 bookDescription1 bookName2 bookPic2 bookDescription2 bookName3 bookPic3 bookDescription3
      degree {
        id code nameLocal nameEng
      }
      subjectGroup {
        id code nameLocal nameEng
      }
      subject {
        id code nameLocal nameEng
      }
      teacher {
        id code firstNameLocal lastNameLocal firstNameEng lastNameEng picturePath
      }
      courseOutlineUnits {
        id seq nameLocal nameEng descriptionLocal descriptionEng preTestExpectScore
        postTestExpectScore unitAgenda unitObjective unitReference
      }
      courseOutlineAssessments {
        id seq percent score
        assessment{
          id nameLocal nameEng
        }
      }
      vdoSets {
        id code description totalVdoLength
        vdoSetUnits {
          id unitSeq code totalVdoLength status remark
          vdoSetTopics {
            id no nameLocal nameEng vdoLength vdoStreamPath isEnabled remark
            playbackUrl
            playbackStatus
            videoProvider
            bunnyVideoGuid
            bunnyStatus
          }
        }
      }
    }
  }
`;

export const UPDATE_COURSEOUTLINE = gql`
  mutation updateCourseOutline(
    $id: ID!,
    $courseOutlineInput: CourseOutlineInput!
  ) {
    updateCourseOutline (
      id: $id,
      courseOutlineInput: $courseOutlineInput,
    ) {
      id subjectCode teacherCode totalPoint instruction streamIntroPath bookName1 picturePath verticalPicturePath
      bookPic1 bookDescription1 bookName2 bookPic2 bookDescription2 bookName3 bookPic3 bookDescription3
      degree {
        id code nameLocal nameEng
      }
      subjectGroup {
        id code nameLocal nameEng
      }
      subject {
        id code nameLocal nameEng
      }
      teacher {
        id code firstNameLocal lastNameLocal firstNameEng lastNameEng picturePath
      }
      courseOutlineUnits {
        id seq nameLocal nameEng descriptionLocal descriptionEng preTestExpectScore
        postTestExpectScore unitAgenda unitObjective unitReference
      }
      courseOutlineAssessments {
        id seq percent score
        assessment{
          id nameLocal nameEng
        }
      }
      vdoSets {
        id code description totalVdoLength
        vdoSetUnits {
          id unitSeq code totalVdoLength status remark
          vdoSetTopics {
            id no nameLocal nameEng vdoLength vdoStreamPath isEnabled remark
            playbackUrl
            playbackStatus
            videoProvider
            bunnyVideoGuid
            bunnyStatus
          }
        }
      }
    }
  }
`;

export const DELETE_COURSEOUTLINE = gql`
  mutation deleteCourseOutline(
    $id: ID!
  ) {
    deleteCourseOutline (
      id: $id
    ) {
      id subjectCode teacherCode totalPoint instruction streamIntroPath bookName1
      bookPic1 bookDescription1 bookName2 bookPic2 bookDescription2 bookName3 bookPic3 bookDescription3
      degree {
        id code nameLocal nameEng
      }
      subjectGroup {
        id code nameLocal nameEng
      }
      subject {
        id code nameLocal nameEng
      }
      teacher {
        id code firstNameLocal lastNameLocal firstNameEng lastNameEng picturePath
      }
      courseOutlineUnits {
        id seq nameLocal nameEng descriptionLocal descriptionEng preTestExpectScore
        postTestExpectScore unitAgenda unitObjective unitReference
      }
      courseOutlineAssessments {
        id seq percent score
        assessment{
          id nameLocal nameEng
        }
      }
      vdoSets {
        id code description totalVdoLength
        vdoSetUnits {
          id unitSeq code totalVdoLength status remark
          vdoSetTopics {
            id no nameLocal nameEng vdoLength vdoStreamPath isEnabled remark
            playbackUrl
            playbackStatus
            videoProvider
            bunnyVideoGuid
            bunnyStatus
          }
        }
      }
    }
  }
`;


// Feeds the borrow-video picker's course-outline type-ahead. Deliberately
// narrow: the select needs a label and an id, nothing else. Widening it makes
// every keystroke more expensive.
export const GET_COURSEOUTLINES_BY_CODE_OR_NAME = gql`
  query getCourseOutlinesByCodeOrName($codeOrName: String!, $limit: Int) {
    getCourseOutlinesByCodeOrName(codeOrName: $codeOrName, limit: $limit) {
      id
      subjectCode
      teacherCode
      subject { id nameLocal nameEng }
      teacher { id firstNameLocal lastNameLocal }
    }
  }
`;

/* TYPES

input CourseOutlineFilterInput {
    degreeId:         ID
    subjectGroupId:   ID
    subjectId:        ID
    subjectCode:      String
    teacherId:        ID
    teacherCode:      String
}

input CourseOutlineInput {
    totalPoint:       Int
    instruction:      String
    streamIntroPath:  String
    bookName1:        String
    bookPic1:         String
    bookDescription1: String
    bookName2:        String
    bookPic2:         String
    bookDescription2: String
    bookName3:        String
    bookPic3:         String
    bookDescription3: String
}

type CourseOutline {
    id:               ID!
    degree:           Degree!
    subjectGroup:     SubjectGroup!
    subject:          Subject!
    subjectCode:      String!
    teacher:          Teacher!
    teacherCode:      String!
    totalPoint:       Int
    instruction:      String
    streamIntroPath:  String
    bookName1:        String
    bookPic1:         String
    bookDescription1: String
    bookName2:        String
    bookPic2:         String
    bookDescription2: String
    bookName3:        String
    bookPic3:         String
    bookDescription3: String
    courseOutlineUnits:         [CourseOutlineUnit]
    courseOutlineAssessments:   [CourseOutlineAssessment]
    isDisabled:       Boolean!
    createdAt:        String!
    updatedAt:        String!
    createdBy:        User
    updatedBy:        User
}

*/
